<template>
  <div class="page">
    <van-list :error.sync="error" error-text="请求失败，点击重新加载" v-model="loading" :finished="finished" finished-text="已加载完毕"
              @load="loadData">
      <div v-for="item in list" :key="item.id" class="item app-card">
        <div class="title">{{ item.recordYearMonth }}</div>
        <div class="content">
          <div class="big">{{ item.name }}</div>
          <div class="big">{{ item.realAmount }}</div>
        </div>
        <div class="content">
          <div>应发</div>
          <div>{{ item.yifaAmount }}</div>
        </div>
        <div class="content">
          <div>个税</div>
          <div>{{ item.geshui }}</div>
        </div>
        <div class="content">
          <div>实发</div>
          <div>{{ item.realAmount }}</div>
        </div>
        <div v-if="item.showDetail" class="expend-content">
          <excel-row :data="item"></excel-row>
          <template v-if="item.contentRemark&&item.contentRemark!='null'">
            <van-divider style="margin: 8px;">说明</van-divider>
            <div style="font-size: 14px;white-space: pre-line;" v-html="item.contentRemark"></div>
          </template>
        </div>
        <div class="expend" @click="item.showDetail = !item.showDetail">
          <div><span>详情<van-icon :name="item.showDetail?'arrow-up':'arrow-down'"/></span></div>
        </div>
      </div>
    </van-list>
    <bind-personnel ref="bindPersonnel" @success="loadData"></bind-personnel>
  </div>
</template>
<style scoped>
.page {
  box-sizing: border-box;
}

.item {
  position: relative;
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
}

.item .title {
  font-size: 20px;
  width: 100px;
  margin-top: 13px;
  background: #408CF8;
  height: 28px;
  line-height: 28px;
  border-top-right-radius: 14px;
  border-bottom-right-radius: 14px;
  color: #fff;
  text-align: center;
}

.content {
  display: flex;
  flex-direction: row;
  flex-flow: row nowrap;
  justify-content: space-between;
  padding: 4px 20px;
  color: #333333;
  font-size: 14px;
  font-weight: bold;
}

.content .big {
  font-size: 20px;
  margin-top: 10px;
}

.expend {
  text-align: center;
  border-top: 1px solid #eeeeee;
  color: #408CF8;
  font-size: 12px;
  padding: 5px;
}

.expend-content {
  border-top: 1px solid #eeeeee;
  margin-top: 10px;
  padding-top: 15px;
  padding-bottom: 10px;
}

</style>
<script>
import {getList} from '@/api/gongzi.js';
import ExcelRow from '@/components/ExcelRow.vue';
import nativeApi from '@/utils/native-bridge';
import BindPersonnel from '@/components/BindPersonnel';
import mixinLoad from '@/mixin/mixin-load.js';
import {checkService} from "@/api/user";

export default {
  name: 'Gongzi',
  components: {
    ExcelRow,
    BindPersonnel
  },
  mixins: [mixinLoad],
  data() {
    return {
      query: {
        limit: 20,
        page: 0,
        type: 20
      },
      list: [],
      loading: false,
      finished: false,
      error: false,
    };
  },
  methods: {
    loadData() {
      this.loading = true;
      this.error = false;
      const targetPage = this.query.page + 1;
      getList(
          Object.assign({}, this.query, {
            page: targetPage
          })
      ).then(({data}) => {
        this.query.page = targetPage;
        if (data.items && data.items.length) {
          data.items.forEach((item) => {
            item.headers = item.sourceRowHeaderGr;
            item.row = item.sourceRowContentGr;
            item.showDetail = false;
            delete item.sourceRowHeaderGr;
            delete item.sourceRowContentGr;
          })
          this.list = this.list.concat(data.items);
          this.loading = false;
        } else {
          this.finished = true;
          this.loading = false;
        }
      }).catch(rep => {
        this.error = true;
        this.loading = false;
      });
    }
  },
  created() {
    Promise.all([checkService('needResign'), this.preCheck()]).then(() => {

    })
  }
};
</script>
